<div class="card">
  <app-header
    titulo="Contratos modificados"
    descricao="Realizar a integração dos contratos modificados"
  ></app-header>


  <app-contratos statusContrato="AT"></app-contratos>

</div>
